<template>
        <b-form-group
          id="fieldset-horizontal"
          label-cols-sm="4"
          label-cols-lg="3"
          :label="action.name"
          :label-for="action.id"
        >
          <template v-slot:label>
            {{action.name}}
            <span v-if="action.dataToCollect && action.dataToCollect[0] && action.dataToCollect[0].mandatory">*</span>
          </template>
            <div v-for="data in action.dataToCollect" :key="data.id" >
              <b-input-group>
                <Prompts v-bind:prompts="action.prompts" v-bind:action="action"></Prompts>

                <DataToCollect v-if="slots && slots[data.id]" v-bind:dataslot="slots[data.id]"></DataToCollect>
              </b-input-group>
            </div>

        </b-form-group>
</template>

<script>
import Prompts from '@/components/Prompts'
import DataToCollect from '@/components/DataToCollect'

export default {
  name: 'CollectInformationAction',
  props: ['action'],
  components: {
    Prompts,
    DataToCollect
  },
  computed: {
    slots () {
      if( this.$store.state.dialogState ) {
        return this.$store.state.dialogState.slots;
      } else {
        return null;
      }
    }
  },
  methods: {
    selectSuggestion(data, value) {
      document.getElementById(data.id).value=value;
      document.getElementById(data.id).classList.add("is-valid");
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
